// Presentation only: Voiceflow decides who is speaking; this just maps its signal to a portrait.
// fx/fy = face centre as a fraction of the image; k = zoom inside the round frame; ratio = height / width.
export const SPECIALISTS = {
  verdant: { name: "Dr. Verdant", title: "Lead Landscape Diagnostician", src: "/team/verdant.webp", face: "/team/face/verdant.webp", fx: 0.5, fy: 0.27, k: 1.8, ratio: 1 },
  cruz: { name: "Dr. Valentina Cruz", title: "Plant Pathology & Arboriculture Specialist", src: "/team/cruz.webp", face: "/team/face/cruz.webp", fx: 0.49, fy: 0.32, k: 1.6, ratio: 1 },
  monroe: { name: "Dr. Elise Monroe", title: "Entomology & Pest Research Specialist", src: "/team/monroe.webp", face: "/team/face/monroe.webp", fx: 0.54, fy: 0.32, k: 1.6, ratio: 1 },
  edwards: { name: "Carlos \u201cLos\u201d Edwards", title: "Horticulture & Landscape Solutions Specialist", src: "/team/edwards.webp", face: "/team/face/edwards.webp", fx: 0.47, fy: 0.25, k: 1.15, ratio: 1.5 },
};
export const DEFAULT_SPECIALIST = "verdant";
export const SPECIALIST_EVENT = "gf:specialist";

const ALIASES = { carlos: "edwards" };

export const specialistId = (payload) => {
  let p = payload;
  if (typeof p === "string") {
    try { p = JSON.parse(p); } catch { p = { id: p }; }
  }
  const raw = String(p?.id || "").trim().toLowerCase();
  const id = ALIASES[raw] || raw;
  return SPECIALISTS[id] ? id : DEFAULT_SPECIALIST;
};

export const specialistExtension = {
  name: "gf_specialist",
  type: "effect",
  match: ({ trace }) => trace?.type === "specialist" || trace?.payload?.name === "specialist",
  effect: ({ trace }) => {
    const raw = trace?.type === "specialist" ? trace.payload : trace?.payload?.payload ?? trace?.payload;
    window.dispatchEvent(new CustomEvent(SPECIALIST_EVENT, { detail: { id: specialistId(raw) } }));
  },
};
